import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import {cScene} from '../creator/cScene'


export class resultDisplay extends cDisplay {

  init(){
    super.init()
    console.log('INIT Result');
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
    })
  }

  buildScene(){    
    super.buildScene();
  }

}
